export default "__VITE_ASSET__B9rRq77U__"